import { makeStyles, createStyles } from '@material-ui/core/styles';
import theme from 'styles/theme';

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      height: 20,
      marginBottom: 20,
      marginTop: 20,
    },
    title: {
      fontSize: 18,
      fontWeight: 'bold',
      color: theme.palette.text.secondary,
    },
    titleBox: {
      marginBottom: 10,
      padding: 5,
    },
    settings: {
      backgroundColor: 'rgba(0,0,0,0.03)',
      borderRadius: 5,
      padding: 20,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'start',
      marginLeft: 40,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        // background: 'red',
        marginLeft: 0,
      },
    },
    winners: {
      width: '50%',
      textAlign: 'center',
      marginTop: 15,
      marginBottom: 15,
      color: 'white',
      fontSize: 20,
      fontWeight: 'bold',
      padding: 15,
      borderRadius: 5,
      border: '1px solid rgba(0,0,0,0.09)',
      backgroundColor: theme.palette.primary.main,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    container: {
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    rouletteStyles: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        padding: 5,
      },
    },
    containerTextArea: {
      border: '1px solid rgba(0,0,0,0.1)',
      borderRadius: 5,
      width: '100%',
      height: '400px',
    },
    boxColor: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 20,
      border: '1px solid #EBECF4',
    },
    buttonSort: {
      borderRadius: 5,
      padding: '5px 50px',
      margin: 5,
      height: 52,
      textTransform: 'none',
    },
    buttonColor: {
      borderRadius: 5,
      padding: 5,
      margin: 5,
      width: 150,
      height: 30,
      textTransform: 'none',
      transform: 'filter 0.3s',
      '&:hover': {
        filter: 'brightness(0.95)',
      },
    },

    buttonSave: {
      margin: '30px auto 0',
      borderRadius: 5,
      height: 45,
      border: 0,
      padding: '4px 20px',
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },

    picker: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
    },
  }),
);

export default useStyles;
